import { nullableString } from 'shared-code/conversion'
import { DSContactsPage } from 'shared-definitions/types'
import { makeHiddenInput } from 'data-source/helpers/makeHiddenInput'
import { ApiContactsPageProps } from 'data-source/types.wp'
import { formFieldsMapper } from 'data-source/mappers/formFieldsMapper'
import { headPropsMapper } from 'data-source/mappers/headPropsMapper'
import { metaMapper, MetaMapperOpts } from 'data-source/mappers/metaMapper'
import { pLinkExternalMapper } from './pLinkMapper'

interface ContactsPageMapperOpst extends MetaMapperOpts {
  pagePath: string
}

export function contactsPageMapper(
  input: ApiContactsPageProps,
  opts: ContactsPageMapperOpst
): DSContactsPage {
  return {
    resource: 'contact-page',
    sections: null,
    head: headPropsMapper(input.head),
    meta: metaMapper(input, ['Contacts'], opts),
    ampPagePath: null,
    pagePath: opts.pagePath,
    title: input.content.title,
    text: nullableString(input.content.text),
    emails: input.content.email ?? [],
    advertise: {
      title: input.content.promo_title,
      button: {
        pLink: pLinkExternalMapper(input.content.button_link),
        label: input.content.button_label,
      },
    },
    form: {
      title: input.content.form_title,
      fields: [
        ...input.content.fields.map(formFieldsMapper),
        makeHiddenInput('page_id', input.content.ID.toString()),
      ],
    },
  }
}
